import gql from 'graphql-tag';

/**
 * Mutation to reorder sections and items within sections of an inspection
 * template in a single atomic gesture.
 */
export const reorderInspectionTemplateMutation = gql`
  mutation ReorderInspectionTemplate(
    $input: ReorderInspectionTemplateInput!
  ) {
    reorderInspectionTemplate(input: $input) {
      success
      newVersion
    }
  }
`;
